import request from '@/utils/request'

// 提交留言接口
export function setMessage (data) {
  return request({
    url: '/SolutionApi/GuestBookSubmit',
    method: 'post',
    data
  })
}
// 提获取方案
export function GainProject (data) {
  return request({
    url: '/SolutionApi/GainProjectSubmit',
    method: 'post',
    data
  })
}